/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DesignProjectTileStatusBadge_designProject = {
    readonly status: string | null;
    readonly visibility: boolean | null;
    readonly " $refType": "DesignProjectTileStatusBadge_designProject";
};
export type DesignProjectTileStatusBadge_designProject$data = DesignProjectTileStatusBadge_designProject;
export type DesignProjectTileStatusBadge_designProject$key = {
    readonly " $data"?: DesignProjectTileStatusBadge_designProject$data;
    readonly " $fragmentRefs": FragmentRefs<"DesignProjectTileStatusBadge_designProject">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "DesignProjectTileStatusBadge_designProject",
  "type": "designProject",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "status",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "visibility",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'c40e9bc064687d0b6195968230d6a9a1';
export default node;
